{
  "cms.catalogRow.action.copyUnitToLocale.sv": "Copy to the Swedish drafts",
  "cms.catalogRow.action.copyUnitToLocale.en": "Copy to the English drafts",
  "cms.copyUnitToLocale.unavailable.noCategories": "This language has no content categories yet.",
  "cms.copyUnitToLocale.unavailable.categoryMissing": "The content category \"{slug}\" does not exist in this language yet.",
  "cms.copyUnitToLocale.done.sv": "Copy created in the Swedish drafts.",
  "cms.copyUnitToLocale.done.en": "Copy created in the English drafts.",
  "cms.copyUnitToLocale.error.slugTaken": "The copy was not created: this content already exists in this language.",
  "cms.copyUnitToLocale.error.incompleteUnit": "This content cannot be copied: it is not a complete publication unit.",
  "cms.copyUnitToLocale.error": "Copying failed. Please try again."
}
